import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";

import Button from "common-components/Buttons";
import Modal from "common-components/Modal/Modal";
import { replaceHashValues } from "utils/replaceHashValues";

const PendingDownload = ({
  modalContent: { section_title, section_description, buttons },
  closeModal,
  dateOfRequest,
  ...props
}) => {
  return (
    <Modal visibleModal closeModal={closeModal} contentLabel="pending download modal" {...props}>
      <h2 style={{ maxWidth: "421px", marginBottom: "24px" }}>{convertStringToElements(section_title)}</h2>
      <Div>
        {convertStringToElements(
          replaceHashValues(section_description, {
            requesteddate: dateOfRequest
          })
        )}
      </Div>

      <Button background={buttons[0].type} onClick={closeModal}>
        {buttons[0].text}
      </Button>
    </Modal>
  );
};

export { PendingDownload };

PendingDownload.propTypes = {
  closeModal: PropTypes.func.isRequired
};

const Div = styled.div`
  max-width: 424px;
  margin-bottom: 35px;

  p {
    padding: 8px 0;
  }
`;
